<template>
  <div class="container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="form">
      <div class="fild_label">
        <span></span>
        <div>员工姓名</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.nickname"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span></span>
        <div>工号</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.empNo"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span></span>
        <div>员工部门</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.position"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <!-- <div class="fild_label">
        <span>*</span>
        <div>个人公益类型</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.pbTypeText"
          placeholder="请选择公益类型"
          disabled
        />
      </div> -->
      <div class="fild_label" v-if="baseinfo.pbType == 2">
        <span>*</span>
        <div>志愿服务类型</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 2">
        <van-radio-group disabled v-model="baseinfo.assort" direction="horizontal">
          <van-radio name="社区志愿服务" style="font-size: 14px;">社区志愿服务</van-radio>
          <van-radio name="扶贫济困" style="font-size: 14px;">扶贫济困</van-radio>
          <van-radio name="支教助学" style="font-size: 14px;">支教助学</van-radio>
        </van-radio-group>
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 4">
        <span>*</span>
        <div>公益捐款类型</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 4">
        <van-radio-group disabled v-model="baseinfo.assort" direction="horizontal">
          <van-radio name="公益基金会" style="font-size: 14px;">公益基金会</van-radio>
          <van-radio name="慈善机构" style="font-size: 14px;">慈善机构</van-radio>
        </van-radio-group>
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>参加公益日期</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.enterTime"
          placeholder="请选择公益日期"
          readonly
          clickable
          disabled
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 1">
        <span>*</span>
        <div>献血量/ml</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 1">
        <van-field
          type="number"
          v-model="baseinfo.blood"
          placeholder="请输入献血量"
          disabled
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 2">
        <span>*</span>
        <div>公益时长</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 2">
        <van-field
          v-model="baseinfo.hour"
          placeholder="请输入公益时长"
          disabled
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 3">
        <span>*</span>
        <div>公益活动</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 3">
        <van-field
          v-model="baseinfo.money"
          placeholder="请输入活动类型"
          disabled
        />
      </div>
      <div
        v-if="baseinfo.pbType == 3"
        style="font-size: 12px; color: #666; margin: -10px 0 10px"
      >
        例如：蚂蚁森林,美团公益,水滴公益
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 4">
        <span>*</span>
        <div>捐款金额/元</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 4">
        <van-field
          type="number"
          v-model="baseinfo.money"
          placeholder="请输入捐款金额"
          disabled
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 5">
        <span>*</span>
        <div>估算价值/元</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 5">
        <van-field
          type="number"
          v-model="baseinfo.money"
          placeholder="请输入估算价值"
          disabled
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 6">
        <span>*</span>
        <div>公益时长/h</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 6">
        <van-field
          type="number"
          v-model="baseinfo.hour"
          placeholder="请输入公益时长"
          disabled
        />
      </div>
      <div
        class="fild_label"
        v-if="baseinfo.pbType != 2 && baseinfo.pbType != 6"
      >
        <span></span>
        <div>换算公益时长/h</div>
      </div>
      <div
        class="fild_value"
        v-if="baseinfo.pbType != 2 && baseinfo.pbType != 6"
      >
        <van-field
          v-model="baseinfo.lngTime"
          placeholder="请输入换算公益时长"
          disabled
        />
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>证明材料（限2024年1月1日后的公益活动）</div>
      </div>
      <div class="fild_value fild_value_upload">
        <!-- <el-upload
          :action="`${upload}/file/upload`"
          list-type="picture-card"
          :file-list="beforeImageList"
          :on-success="handleBeforeImage"
          accept=".jpg,.jpeg,.png"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="previewBeforeImage(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload> -->
        <div v-for="(item, index) in baseinfo.image" :key="index">
          <img @click="previewBeforeImage(item)" :src="imgUrl + item" alt="" />
        </div>
      </div>
      <div class="fild_label" v-if="type == 2 && baseinfo.auditNo">
        <span>*</span>
        <div>审批人</div>
      </div>
      <div class="fild_value" v-if="type == 2 && baseinfo.auditNo">
        <van-field v-model="baseinfo.auditName" placeholder="审批人" disabled />
      </div>
      <div class="fild_label" v-if="type == 2 && baseinfo.auditNo">
        <span>*</span>
        <div>审批时间</div>
      </div>
      <div class="fild_value" v-if="type == 2 && baseinfo.auditNo">
        <van-field
          v-model="baseinfo.auditTime"
          placeholder="审批时间"
          disabled
        />
      </div>
    </div>
    <div class="footer" v-if="type == 1 && baseinfo.state == 1">
      <el-button class="btn1" @click="showSignIn = true">通过</el-button>
      <el-button class="btn2" @click="showSignOut = true">驳回</el-button>
    </div>
    <div class="footer" v-if="type == 1 && baseinfo.state != 1">
      <el-button class="btn3" disabled>已审批</el-button>
    </div>
    <!-- <van-dialog
      v-model="showTime"
      title="添加时间"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="valueTime"
        label="时间选择"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom" get-container="body">
        <van-datetime-picker
          type="date"
          v-model="currentTime"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <div class="dialog_footer">
        <el-button @click="cancal">取消</el-button>
        <el-button @click="addTime">确认</el-button>
      </div>
    </van-dialog> -->
    <!-- <van-dialog
      v-model="showExamine"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <div class="dialog_header_con">
        <div class="left">提交审批</div>
        <van-icon name="cross" @click="cancleExamine" />
      </div>
      <div class="examine_con">
        <div class="con_tit">审批人</div>
        <div class="img_con">
          <img :src="examineInfo.icon" alt="" />
        </div>
        <div class="name">{{ examineInfo.nickname }}</div>
      </div>
      <div class="dialog_footer1">
        <el-button @click="cancleExamine">取消</el-button>
        <el-button @click="submitExamine">提交审批</el-button>
      </div>
    </van-dialog> -->
    <el-dialog :visible.sync="dialogVisibleImg" class="dialogImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <van-dialog
      v-model="showSignIn"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <div class="dialog_header_con">您是否确认通过？</div>
      <div class="dialog_footer1">
        <el-button @click="showSignIn = false">取消</el-button>
        <el-button @click="submit">确认</el-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSignOut"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <!-- <div class="dialog_header_con">您是否确认驳回？</div> -->
      <div class="dialog_header_inp">
        <van-field
          v-model="message"
          rows="3"
          label="驳回理由"
          type="textarea"
          placeholder="请输入留言"
          label-width="70px"
        />
      </div>
      <div class="dialog_footer1">
        <el-button @click="showSignOut = false">取消</el-button>
        <el-button @click="no">确认</el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import moment from "moment";
// import moment from 'moment/moment';
export default {
  name: "my",
  props: {},
  components: {},
  data() {
    return {
      dialogVisibleImg: false,
      dialogImageUrl: "",
      baseinfo: {
        nickname: "",
        empNo: "",
        position: "",
        pbType: "",
        pbTypeText: "",
        enterTime: "",
        blood: "",
        money: "",
        hour: "",
        image: [],
        lngTime: "",
        points: "",
        auditNo: "",
        auditName: "",
        auditTime: "",
        state: "",
        assort:''
      },
      optionType: [],
      // welfareList: [],
      showTime: false,
      valueTime: "",
      showPicker: false,
      showPickerTwo: false,
      currentTime: new Date(),
      tagTimeList: [],
      beforeImageList: [],
      showExamine: false,
      valueExamine: "",
      examineInfo: {},
      upload: "",
      userinfo: {},
      imgUrl: "",
      showSignIn: false,
      showSignOut: false,
      message: "经审核,证明材料不齐全,请及时补充更正",
      // 获取路由参数
      id: "",
      type: "",
    };
  },

  created() {},
  computed: {},
  mounted() {
    // const { nickname, username, position } = this.$store.state.userInfo;
    // this.baseinfo.nickname = nickname;
    // this.baseinfo.empNo = username;
    // this.baseinfo.position = position;
    this.imgUrl = api.imgUrl;
    const { type, id } = this.$route.query;
    this.id = id;
    this.type = type;
    // this.baseinfo.pbType = Number(type);
    // this.getSelect();
    this.queryParentName();
    this.getUserinfo();
    this.upload = api.upload;
  },
  beforeDestroy() {},
  methods: {
    // 获取用户信息
    getUserinfo() {
      apis.auditDetail({ id: this.id }).then((res) => {
        if (res.code == 200) {
          // this.userinfo = res.data;
          const data = res.data;
          this.baseinfo.nickname = data.empName;
          this.baseinfo.empNo = data.empNo;
          this.baseinfo.position = data.departmentName;
          this.baseinfo.pbType = data.pbType;
          this.baseinfo.enterTime = data.enterTime
            ? moment(data.enterTime).format("YYYY-MM-DD")
            : "暂无";
          this.baseinfo.blood = data.blood;
          this.baseinfo.hour = data.hour;
          this.baseinfo.money = data.money;
          this.baseinfo.departmentName = data.departmentName;
          this.baseinfo.lngTime = data.hour;
          this.baseinfo.auditNo = data.auditNo;
          this.baseinfo.auditName = data.auditName ? data.auditName : "暂无";
          this.baseinfo.image = data.image ? data.image.split(",") : [];
          this.baseinfo.state = data.state;
          this.baseinfo.assort = data.assort;
          this.baseinfo.auditTime = data.auditTime
            ? moment(data.auditTime).format("YYYY-MM-DD")
            : "暂无";
          this.getSelect();
        }
      });
    },
    //上传
    handleBeforeImage(file) {
      console.log(file, "file");

      this.baseinfo.image.push(file.id);
    },
    //删除
    handleRemove(file) {
      const index = this.baseinfo.image.findIndex(
        (item) => file.response.id == item
      );
      this.baseinfo.image.splice(index, 1);
    },
    // 图片放大预览
    previewBeforeImage(item) {
      this.dialogImageUrl = api.imgUrl + item;
      this.dialogVisibleImg = true;
    },
    //返回
    goback() {
      this.$router.go(-1);
    },
    //获取公益类型
    getSelect() {
      apis.getTypeList().then((res) => {
        if (res.code == 200) {
          console.log(res, "res");
          this.optionType = res.data;
          let text = "";
          this.optionType.forEach((item) => {
            if (item.id == this.baseinfo.pbType) {
              text = item.name;
            }
          });
          this.baseinfo.pbTypeText = text;
        }
      });
    },
    // 提交审批
    submit() {
      // const type = this.baseinfo.pbType;
      // const index = this.optionType.find((item) => item.id == type);
      const { apply } = this.$route.query;
      const params = {
        id: this.id,
        auditNo: this.$store.state.userInfo.username,
        state: 2,
      };
      if (apply == 1) {
        apis.adminAudit(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审批通过成功",
              type: "success",
            });
            this.getUserinfo();
            this.showSignIn = false;
            this.$router.go(-1);
          }
        });
      } else {
        apis.audit(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审批通过成功",
              type: "success",
            });
            this.getUserinfo();
            this.showSignIn = false;
            this.$router.go(-1);
          }
        });
      }

      console.log(params, "params222");
    },
    // 驳回审批
    no() {
      // this.$router.go(-1);
      const { apply } = this.$route.query;
      const params = {
        id: this.id,
        auditNo: this.$store.state.userInfo.username,
        state: 3,
        reason: this.message,
      };
      if (apply == 1) {
        apis.adminAudit(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审批驳回成功",
              type: "success",
            });
            this.getUserinfo();
            this.showSignOut = false;
            this.$router.go(-1);
          }
        });
      } else {
        apis.audit(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审批驳回成功",
              type: "success",
            });
            this.getUserinfo();
            this.showSignOut = false;
            this.$router.go(-1);
          }
        });
      }
      // const params = {
      //   id: this.id,
      //   auditNo: this.baseinfo.auditNo,
      //   state: 3,
      //   reason: this.message,
      // };
      console.log(params, "params222");
    },
    //根据工号查询上级
    queryParentName() {
      api
        .queryParentNameApi({ userName: this.$store.state.userInfo.username })
        .then((res) => {
          if (res.code == 200) {
            this.examineInfo = res.data;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .container {
    width: 100%;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}

@media screen and (min-width: 600px) {
  .container {
    width: 276px * $zoom;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}

.container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #ffffff;
  padding: 30px;
  .form {
    width: 100%;
    background: #fff;
    border-radius: 25px;
    padding: 30px;
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 26px;
      }
    }
    .fild_value_upload {
      div {
        display: flex;
        flex-wrap: wrap;
        img {
          width: 200px;
          height: 200px;
        }
      }
    }
    .fild_value {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      align-items: center;

      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
      img {
        margin-left: 20px;
        width: 55px;
        height: 55px;
      }
    }
    .tagList {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 30px;
      font-size: 10px * $zoom;
      margin: 30px 0;
      .tag_item {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 30px;
      }
      i {
        margin-left: 30px;
      }
    }
  }
}
.footer {
  .btn2 {
    border: 1px solid #1fbe8a;
    background: none;
    color: #1fbe8a;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 0 0 30px !important;
    border-radius: 15px;
  }
  .btn1 {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px;
    border-radius: 15px;
  }
  .btn3 {
    border: 1px solid #ccc;
    background: none;
    color: #ccc;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px !important;
    border-radius: 15px;
  }
}
::v-deep {
  .van-dialog__content {
    margin-top: 20px;
  }
  .el-upload--picture-card {
    width: 200px;
    height: 200px;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-list {
    display: flex;
    li {
      width: 200px;
      height: 200px;
      div {
        width: 100%;
        height: 100%;
        img {
          width: 100% !important;
          height: 100% !important;
          margin-left: 0 !important;
        }
      }
    }
  }
  .dialogImg {
    .el-dialog {
      margin-top: 0 !important;
      width: 100% !important;
      margin: 0 !important;
      .el-dialog__body {
        height: calc(100vh - 55px);
        overflow: auto;
      }
    }
  }
}
.dialog_footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 30%;
    height: 65px;
    font-size: 10px * $zoom;
  }
  button:nth-child(1) {
    border: 1px solid #1fbe8a;
    background: #fff;
    color: #1fbe8a;
  }
  button:nth-child(2) {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
}
.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.dialog_header_con {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  .left {
    color: #282b32;
    font-size: 30px;
  }
}
.dialog_header_inp {
  ::v-deep {
    .van-field__body {
      background: #ececec;
      border-radius: 20px;
      padding: 20px;
    }
  }
}
.examine_con {
  padding: 10px 25px;
  .con_tit {
    color: #666666;
    margin: 20px 0;
  }
  .name {
    text-align: center;
    font-size: 30px;
  }
  .img_con {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
  }

  ::v-deep {
    .van-cell {
      display: flex;
      flex-direction: column;
    }
    .van-field__body {
      background: #fafafa;
      border-radius: 40px;
      height: 85px;
      padding: 0 30px;
      margin-top: 20px;
    }
    .van-icon {
      // margin-right: 20px;
    }
  }
}
.dialog_footer1 {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 40%;
    height: 65px;
    font-size: 10px * $zoom;
    border-radius: 15px;
  }
  button:nth-child(1) {
    border: 1px solid #999999;
    background: #fff;
    color: #999999;
  }
  button:nth-child(2) {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
}

.dialog_header_con {
  width: 100%;
  padding: 60px 25px;
  text-align: center;
}
</style>
